import React from 'react';
import {
  Modal,
  Steps,
  Button,
  Checkbox,
  Alert,
  List,
  notification
} from 'antd';
import { unlistItems } from '../api';
const { Step } = Steps;

export default class extends React.Component {
  state = {
    step: 0,
    status: 'wait',
    apiErrors: [],
    apiInfo: [],
    channelIds: []
  };

  onToggleChannel = (channel, e) => {
    this.setState(prevState => ({
      channelIds: prevState.channelIds
        .filter(id => id !== channel.id)
        .concat(e.target.checked ? channel.id : null)
        .filter(Boolean)
    }));
  };

  removeListings = async () => {
    this.setState({ status: 'process' });

    const { selections } = this.props;
    const { channelIds } = this.state;
    const skus = selections.map(item => item.sku);

    try {
      const results = await Promise.all(
        channelIds.map(id => unlistItems(id, skus))
      );
      const apiInfo = [].concat(
        ...results.map(result => result.info).filter(Boolean)
      );
      const apiErrors = results
        .map(result => result.status)
        .filter(status => status !== 'OK');
      if (apiErrors.length) {
        const error = new Error('API Error');
        error.state = { apiInfo, apiErrors };
        throw error;
      }

      notification.success({ message: 'Listings removed successfully' });
      this.setState({ step: 1, status: 'finish', apiInfo });
    } catch (err) {
      console.error(err);
      this.setState({ step: 1, status: 'error', ...(err.state || {}) });
      notification.error({ message: 'There were errors during removal' });
    }
  };

  render() {
    const { open, onClose, onComplete, channels } = this.props;
    const { step, status, errors, channelIds } = this.state;

    return (
      <Modal
        title="Remove Listings"
        footer={null}
        visible={open}
        onCancel={onClose}
        centered={true}
      >
        <Steps current={step}>
          <Step title="Select Marketplaces" />
          <Step title="Remove Listings" />
        </Steps>
        <div className="current-step">
          {step === 0 && (
            <div>
              <p>
                Please select the marketplaces where you would like to remove
                your listings.
              </p>
              {channels.map(channel => (
                <div key={channel.id}>
                  <Checkbox
                    checked={channelIds.includes(channel.id)}
                    onChange={e => this.onToggleChannel(channel, e)}
                  />
                  &nbsp;
                  {channel.name}
                </div>
              ))}
              <div className="current-step__buttons">
                <Button onClick={onClose}>Cancel</Button>
                <Button type="danger" onClick={this.removeListings}>
                  Remove
                </Button>
              </div>
            </div>
          )}
          {step === 1 && (
            <div>
              {status === 'process' && <span>Removing..</span>}
              {status === 'error' && (
                <>
                  {this.state.apiErrors.map(error => (
                    <Alert key={error} type="error" message={error} />
                  ))}
                </>
              )}
              {status === 'finish' && (
                <>
                  <Alert
                    message="Listings Removed"
                    description="It may take up to 15 minutes before your listings are reflected in the dashboard."
                    type="success"
                    showIcon
                  />
                  <div className="current-step__results">
                    <List
                      dataSource={this.state.apiInfo}
                      renderItem={item => <List.Item>{item}</List.Item>}
                    />
                  </div>
                </>
              )}
              <div className="current-step__buttons">
                <Button
                  type="primary"
                  disabled={status === 'process'}
                  onClick={onComplete}
                >
                  Finish
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}
